import { ButtonRules, StyledButton } from '@canopysecurity/component-library';
import styled from 'styled-components';
import { CardContainer, CardTitle } from '../../StyledComponents/Card';
import CondorSpinner from '../CondorSpinner';

const StyledSelect = styled.select`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;

  &:focus {
    outline: none;
    border-color: blue;
    box-shadow: 0 0 5px rgba(0, 0, 255, 0.2);
  }
`;

interface DeployOtaToDeviceProps {
  deploymentLoading: boolean;
  deployToDeviceLoading: boolean;
  selectedDeployment: string;
  setSelectedDeployment: (value: string) => void;
  updatedDeployments: Array<{
    id: string;
    release: {
      semver: string;
    };
  }>;
  onDeployToDevice: () => void;
}

export const DeployOtaToDevice = (props: DeployOtaToDeviceProps) => {
  const {
    setSelectedDeployment,
    selectedDeployment,
    updatedDeployments,
    deploymentLoading,
    deployToDeviceLoading,
    onDeployToDevice,
  } = props;

  return (
    <CardContainer>
      <CardTitle>Deploy OTA to Device</CardTitle>
      {deploymentLoading ? (
        <CondorSpinner />
      ) : (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ marginLeft: '1em', flexBasis: '50%' }}>
            <StyledSelect
              value={selectedDeployment}
              onChange={(e) => setSelectedDeployment(e.target.value)}
            >
              <option value="">Select deployment</option>
              {updatedDeployments?.map((deployment) => (
                <option key={deployment.id} value={deployment.id}>
                  {deployment.release.semver}
                </option>
              ))}
            </StyledSelect>
          </div>
          <div style={{ flexBasis: '40%', maxWidth: '230px' }}>
            <StyledButton
              disabled={
                deploymentLoading ||
                deployToDeviceLoading ||
                !selectedDeployment
              }
              onPress={() => onDeployToDevice()}
              buttonRules={ButtonRules.primaryA}
              aria-label="Deploy"
            >
              Deploy
            </StyledButton>
          </div>
        </div>
      )}
    </CardContainer>
  );
};
